import type { CellState, TableAction } from "./types";
import type { Dispatch } from "react";
import { createElement } from "react";
import { encodeCellIdentifier } from "./utils";
import { useOverlayScale } from "../editor/hooks";

type Props = {
  tableId: string;
  cell: CellState;
  dispatch: Dispatch<TableAction>;
};

export function TableCell({ tableId, cell, dispatch }: Props) {
  const overlayScale = useOverlayScale();
  const id = tableId + "-" + encodeCellIdentifier(cell);
  const headers = cell.headers?.map(
    (header) => tableId + "-" + encodeCellIdentifier(header),
  );

  const onMouseDown = (event: React.MouseEvent) => {
    if (!event.ctrlKey) return;
    event.stopPropagation();
    dispatch({ type: "toggleTableCellSelection", cellIdentifier: cell });
  };

  return createElement(cell.role, {
    id,
    className: `table-editor-table-cell ${cell.selected ? "selected" : ""}`,
    style: { borderWidth: `${3 / overlayScale}px` },
    colSpan: cell.colSpan,
    rowSpan: cell.rowSpan,
    scope: cell.scope,
    headers,
    onMouseDown,
    "data-cell-debug-info": JSON.stringify(cell),
  });
}
